import { style } from "@vanilla-extract/css";
import { breakpoints } from "../../styles/breakpoints";
import { vars } from "../../styles/theme.css";
export const scoreboardPanelWrap = style({
  display: "flex",
});

export const scoreboardGrid = style({
  display: "grid",
  gap: vars.space.m,
  "@media": {
    [`screen and (min-width:${breakpoints[1]})`]: {
      gridTemplateColumns: "1fr 1fr",
    },
  },
});
